<script setup lang="ts">
import { computed } from "vue";
import { IconList } from "~/components/ui/IconList";
import { IconListItem } from "~/components/ui/IconList/IconListItem";
import useMarketSetup from "~/composables/useMarketSetup";
import { imagePath, mapNodes } from "~/utils/helper/magnolia";

export interface ShopBenefitsProps {
  benefits?: object[];
}

const { benefits } = defineProps<ShopBenefitsProps>();

const { marketSetup } = useMarketSetup();
const shopBenefits = computed(() => mapNodes(benefits ?? marketSetup.value?.shopBenefits));
</script>

<template>
  <IconList size="small">
    <IconListItem
      v-for="shopBenefit in shopBenefits"
      :key="shopBenefit['@id']"
      :image="{ src: imagePath(shopBenefit.image) }"
      >{{ shopBenefit.label?.value }}</IconListItem
    >
  </IconList>
</template>
